import { Deserializable } from '../../protocols/deserializable';
import { RelationshipStatusType } from '../../types/dto/relationship-status-type';
import { RelationshipStatus } from '../../enum/shared/relationship-status';
import { Spouse } from './spouse';
import * as moment from 'moment';

export class MemberRelationshipStatus implements Deserializable {
  public id!: number;
  public memberId!: number;
  public typeId!: RelationshipStatus;
  public type!: RelationshipStatusType;
  public spouseId?: number;
  public spouse!: Spouse;
  public effectiveDate!: string;
  public endDate?: string;

  // Not From API
  public formattedEffectiveDate!: string;
  public formattedEndDate!: string;

  public onDeserialize() {
    if (!!this.type) {
      this.type = window?.injector?.Deserialize?.instanceOf(RelationshipStatusType, this.type);
    }
    if (!!this.spouse) {
      this.spouse = window?.injector?.Deserialize?.instanceOf(Spouse, this.spouse);
    }
    if (!!this.effectiveDate) {
      this.formattedEffectiveDate = moment.utc(this.effectiveDate).format('MMM D, YYYY');
    }
    if (!!this.endDate) {
      this.formattedEndDate = moment.utc(this.endDate).format('MMM D, YYYY');
    }
  }
}
